import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import {
  revertTeamApprovalApi,
  RevertTeamApprovalPayload,
  RevertTeamApprovalResponse,
  RevertTeamApprovalErrorResponse,
} from 'TeamModule/services/RevertTeamApprovalApi';
import { AxiosResponse } from 'axios';
import { teamQueryKeys } from '../teamQueryKeys';
import { useContextHeaders } from 'hooks/useContextHeaders';

export const useRevertTeamApprovalMutation = () => {
  const token = useSelector(selectAuthToken);
  const queryClient = useQueryClient();
  const { buildConfig } = useContextHeaders();

  const mutation = useMutation<
    AxiosResponse<RevertTeamApprovalResponse>,
    AxiosResponse<RevertTeamApprovalErrorResponse>,
    RevertTeamApprovalPayload
  >({
    mutationFn: async (params) => {
      if (!token) throw new Error('No auth token available');
      // buildConfig() automatically includes URL context headers (tenant/realmId)
      return revertTeamApprovalApi({ params, token, config: buildConfig() }) as Promise<
        AxiosResponse<RevertTeamApprovalResponse>
      >;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: teamQueryKeys.listInvalidation({ identifier: 'useTeamsPendingDeletionQuery' }),
      });
    },
  });

  return {
    revertTeamApproval: mutation.mutate,
    isRevertingTeamApproval: mutation.isPending,
  };
};
